'use strict';

class VZTcProductCard extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Config URL Cache
        this.configUrl = null;

        // Sidebar & Submit
        this.sidebar = document.querySelector('.js-configurator-sidebar');
        this.sidebarSubmitBtns = Array.from(document.querySelectorAll('.js-configurator-submit-btn'));

        if (this.sidebar) this.handleSubmitValidate();

        this.handleSubmitValidate = this.handleSubmitValidate.bind(this);
        this.addEventListener('teamscalling:submitvalidate', this.handleSubmitValidate);

        // Variation
        this.addEventListener('variationChange', this.onVariationChange);
    }

    onVariationChange(evt) {
        const { response } = evt.detail;
        const fragment = document.createElement('template');

        fragment.innerHTML = response;

        this.updateCard(fragment.content.querySelector('vz-tc-product-card').outerHTML);
        this.updateSidebar(fragment);
    }

    updateCard(productCardHTML) {
        if (this.outerHTML) this.outerHTML = productCardHTML;
    }

    updateSidebar(fragment) {
        this.sidebar.dispatchEvent(
            new CustomEvent('sidebar:reinitializesidebar', {
                detail: {
                    fragment: fragment
                }
            })
        );
    }

    handleSubmitValidate() {
        this.disableSubmitButton();

        setTimeout(() => {
            const productCards = Array.from(document.querySelectorAll('.js-teams-calling-product-card'));
            const lastProductCard = productCards[productCards.length - 1];
            const disabledProductCards = Array.from(document.querySelectorAll('[data-card-disabled="true"]'));
            const lastProductCardAnswered = lastProductCard.querySelector('[data-card-answered="true"]');

            if (disabledProductCards.length === 0 && lastProductCardAnswered) {
                this.enableSubmitButton();
            }
        }, 250);
    }

    disableSubmitButton() {
        this.sidebarSubmitBtns = Array.from(document.querySelectorAll('.js-configurator-submit-btn'));
        this.sidebarSubmitBtns.forEach((sidebarSubmitBtn) => {
            sidebarSubmitBtn.classList.add('opacity-50', 'pe-none');
            sidebarSubmitBtn.setAttribute('disabled', true);
        });
    }

    enableSubmitButton() {
        this.sidebarSubmitBtns = Array.from(document.querySelectorAll('.js-configurator-submit-btn'));
        this.sidebarSubmitBtns.forEach((sidebarSubmitBtn) => {
            sidebarSubmitBtn.classList.remove('opacity-50', 'pe-none');
            sidebarSubmitBtn.removeAttribute('disabled');
        });
    }
}

export default window.customElements.get('vz-tc-product-card') || VZTcProductCard;

if (!window.customElements.get('vz-tc-product-card')) {
    window.customElements.define('vz-tc-product-card', VZTcProductCard);
}
